import { FunctionComponent } from "react";

import { QuickAccessPanel } from "@dashboard/components/QuickAccessPanel";
import { QuickActionsPanel } from "@home/components/QuickActionsPanel";

const Dashboard: FunctionComponent = () => {
  return (
    <div className="flex grow gap-10" data-testid="dashboard">
      <div className="flex grow flex-col">
        <QuickAccessPanel />
      </div>
      <div className="w-[200px]">
        <QuickActionsPanel />
      </div>
    </div>
  );
};

export default Dashboard;
